import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7d24e03"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-ho",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-ho-stage",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-ho-ring nge-ho-ring--a" }),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-ho-ring nge-ho-ring--b" }),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-ho-glow" }),
  /*#__PURE__*/_createElementVNode("svg", {
    class: "nge-ho-gem",
    viewBox: "0 0 24 24",
    width: "64",
    height: "64"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5 9 L9 4 L15 4 L19 9 L12 20 Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5 9 H19 M9 4 L12 9 L15 4 M12 9 V20",
      fill: "none",
      stroke: "#6b4c00",
      "stroke-width": "0.6",
      opacity: "0.55"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-ho-title" }, "Entering the Hunt", -1 /* HOISTED */))
const _hoisted_4 = {
  key: 0,
  class: "nge-ho-name"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-ho-bar",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("span")
], -1 /* HOISTED */))
const _hoisted_6 = { class: "nge-ho-step" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Transition, { name: "nge-ho" }, {
    default: _withCtx(() => [
      ($setup.huntState.opening)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            ($setup.huntState.opening.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.huntState.opening.title), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString($setup.huntState.opening.step), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}